<div class="title">
    <div>Auto Segmentation</div>
    <button class="wiki-btn" (click)="goToWiki()">?</button>
</div>
<form class="job-selection-dialog-content">
    <cds-form-group layout="vertical">
        <cds-select>
            <label>Model</label>
            <select
                name="model-selection"
                [ngModel]="selectedModel"
                (ngModelChange)="onModelSelected($event)"
            >
                <option [ngValue]="null">Select a model...</option>
                <ng-container *ngFor="let model of models$ | async">
                    <option [ngValue]="model">{{ model.display_name }}</option>
                </ng-container>
            </select>
        </cds-select>
        <div *ngIf="selectedModel">
            <div *ngFor="let input of modelInputs" class="input-selection-group">
                <label class="input-label">{{ input.name }}</label>
                <span class="layer-summary">{{ getLayersSummary(input.name) }}</span>
                <cds-button size="sm" action="outline" (click)="openSelectLayersDialog(input.name)">
                    Select layers
                </cds-button>
            </div>
        </div>
        <div *ngIf="selectedModel" class="display-name-section">
            <div class="input-label display-name-section-label">Display name</div>
            <div class="display-name-inline">
                <cds-input controlWidth="shrink" class="display-name-input">
                    <label class="display-name-sr-only">Display name</label>
                    <input
                        type="text"
                        name="issueDisplayName"
                        id="autoSegIssueDisplayName"
                        [(ngModel)]="issueDisplayName"
                        autocomplete="off"
                        placeholder="e.g. run 1, tissue A"
                    />
                </cds-input>
                <span class="issue-name-preview" title="How this job may appear on the issue">
                    {{ fullJobDisplayName }}
                </span>
            </div>
        </div>
        <div *ngIf="siblingDatasets!.length > 1">
            <cds-checkbox>
                <label>Run the job on datasets in the same folder</label>
                <input
                    id="runBatchJob"
                    type="checkbox"
                    name="runBatchJob"
                    [(ngModel)]="runBatchJob"
                />
            </cds-checkbox>
            <ul class="batch-datasets" [class.show]="runBatchJob">
                <li *ngFor="let dataset of siblingDatasets">
                    {{ dataset }}
                </li>
            </ul>
        </div>
    </cds-form-group>
</form>
<div class="actions action-buttons">
    <cds-button size="sm" action="flat" (click)="cancel()">Cancel</cds-button>
    <cds-button size="sm" (click)="startJob()" [disabled]="!canStart">Start job</cds-button>
</div>
